// NGRX

// OLCI
import { VdsInfo } from '../models/vds-info';
import { OlciActionTypes } from '../actions';
import { constants } from '../constants/constants';
import { Session, ReservationRetrievalResponse } from '../models';
import { HttpErrorResponse } from '@angular/common/http';

// tslint:disable-next-line:no-empty-interface
export interface State extends Session {
	[k: string]: any
}

export interface State {
	checkinToken: string;
	sessionTimestamp: number;
	sessionWarningModal: boolean;
	loadingSession: boolean;
	loadingSailingInfo: boolean;
	vds: VdsInfo | any;
	reservationRetrievalResp: ReservationRetrievalResponse | any;
	responseErrors: HttpErrorResponse[];
	error: any;
}

export const initialState: State = {
	checkinToken: '',
	sessionTimestamp: 0,
	sessionWarningModal: false,
	loadingSession: false,
	loadingSailingInfo: false,
	vds: null,
	reservationRetrievalResp: null,
	responseErrors: [],
	error: null
};

export function reducer(state = initialState, action: any): State {
	switch (action.type) {

		case OlciActionTypes.POST_SAILING_INFORMATION:
			return Object.assign({}, state, { loadingSailingInfo: true, error: null });

		case OlciActionTypes.STORE_VDS_INFO:
			return Object.assign({}, state, { vds: action.payload });

		case OlciActionTypes.POST_SAILING_INFORMATION_SUCCESS:
			if (action.payload?.status &&  action.payload.status !== constants.HTTP_STATUS_CODE.SUCCESS) {
				return Object.assign({}, state, { loadingSailingInfo: false, responseErrors: action.payload.errors, error: action.payload.status });
			}
			return Object.assign({}, state, {
				loadingSailingInfo: false,
				reservationRetrievalResp: action.payload.payload
			});

		case OlciActionTypes.POST_SAILING_INFORMATION_FAILURE:
			return Object.assign({}, state, {
				loadingSailingInfo: false,
				error: action.payload.error || null
			});

		case OlciActionTypes.UPDATE_LOGGED_IN_GUEST_INFO:
			return Object.assign({}, state, {
				reservationRetrievalResp: Object.assign({}, state.reservationRetrievalResp, {
					bookingId: action.payload.bookingId,
					loggedInPaxId: action.payload.guestId
				})
			});

    case OlciActionTypes.SET_RESPONSE_ERROR: {
      const existingError = state.responseErrors?.find((error: any) => error?.status === action.payload.status);
      return existingError ? state : {...state, ...{ responseErrors: [...state.responseErrors, action.payload] }};
    }

    case OlciActionTypes.SET_RESPONSE_ERROR_CLEAR:
      return {...state, responseErrors: []};

		case OlciActionTypes.UPDATE_CHECKIN_TOKEN: {
			const response = action.payload;
			return Object.assign({}, state, { checkinToken: response });
		}

		default:
			return state;

	}
}

export const getReservationRetrievalResp = (state: State) =>
	state && state.reservationRetrievalResp ? state.reservationRetrievalResp : null;
export const getSessionTimestamp = (state: State) => state.sessionTimestamp;
export const getSessionWarningModal = (state: State) => (state && state.sessionWarningModal ? state.sessionWarningModal : null);
export const getCheckinToken = (state: State) => (state && state.checkinToken ? state.checkinToken : null);
